import { useState } from "react";
import { motion } from "framer-motion";
import SectionHeading from "../../components/ui/SectionHeading";
import PageWrapper from "../../components/layout/PageWrapper";
import FadeIn from "../../components/animations/FadeIn";

const contactInfo = {
  email: "Info@aurainternationalom.com",
  phone: "77240531 / 76363027",
  location: "Muscat, Oman",
  social: [
    { name: "LinkedIn", href: "https://www.linkedin.com/company/aura-international", icon: "linkedin" },
    { name: "Facebook", href: "https://www.facebook.com/aurainternational", icon: "facebook" },
    { name: "Instagram", href: "https://www.instagram.com/aurainternational", icon: "instagram" },
    { name: "Twitter", href: "https://twitter.com/aurainternational", icon: "twitter" },
  ],
};

const SocialIcon = ({ icon, className }) => {
  const c = className || "w-5 h-5";
  switch (icon) {
    case "linkedin":
      return (
        <svg className={c} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
        </svg>
      );
    case "facebook":
      return (
        <svg className={c} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
        </svg>
      );
    case "instagram":
      return (
        <svg className={c} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
        </svg>
      );
    case "twitter":
      return (
        <svg className={c} fill="currentColor" viewBox="0 0 24 24" aria-hidden>
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      );
    default:
      return null;
  }
};

export default function Contact() {
  const [formState, setFormState] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    setFormState((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus(null);

    try {
      const requestBody = {
        Name: formState.name,
        Email: formState.email,
        MobileNo: formState.phone,
        Subject: formState.subject,
        Description: formState.message,
        ToMail: "info@aurainternationalom.com",
      };

      const response = await fetch("https://api.ainsoft.in/sendEnquiry", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      if (response.ok) {
        setFormState({ name: "", phone: "", email: "", subject: "", message: "" });
        setSubmitStatus("success");
      } else {
        setSubmitStatus("error");
      }
    } catch (error) {
      console.error("Error sending email:", error);
      setSubmitStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <PageWrapper>
      <section className="py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <FadeIn>
            <SectionHeading
              overline="Contact"
              title="Let's start a conversation"
              subtitle="Tell us about your project or goals. We'll get back to you as soon as possible."
            />
          </FadeIn>

          <div className="mt-16 grid lg:grid-cols-2 gap-12 lg:gap-20">
            <motion.div
              initial={{ opacity: 0, x: -20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              className="space-y-6"
            >
              <div>
                <h3 className="font-serif text-xl font-semibold text-aura-text mb-2">
                  Aura International Marketing & Business LLC
                </h3>
                <p className="font-sans text-aura-text text-sm">
                  Premium marketing, events, and business solutions.
                </p>
              </div>

              <div className="space-y-4">
                <a
                  href={`mailto:${contactInfo.email}`}
                  className="flex items-center gap-3 text-aura-text hover:text-gold-primary transition-colors"
                >
                  <span className="flex-shrink-0 w-10 h-10 rounded-sm bg-gold-primary/20 flex items-center justify-center text-gold-dark">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" /></svg>
                  </span>
                  <span className="font-sans text-sm break-all">{contactInfo.email}</span>
                </a>
                <a
                  href={`tel:${contactInfo.phone.replace(/\s/g, "")}`}
                  className="flex items-center gap-3 text-aura-text hover:text-gold-primary transition-colors"
                >
                  <span className="flex-shrink-0 w-10 h-10 rounded-sm bg-gold-primary/20 flex items-center justify-center text-gold-dark">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" /></svg>
                  </span>
                  <span className="font-sans text-sm">{contactInfo.phone}</span>
                </a>
                <div className="flex items-start gap-3 text-aura-text">
                  <span className="flex-shrink-0 w-10 h-10 rounded-sm bg-gold-primary/20 flex items-center justify-center text-gold-dark">
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" /><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" /></svg>
                  </span>
                  <span className="font-sans text-sm pt-2">{contactInfo.location}</span>
                </div>
              </div>

              <div className="pt-2">
                <p className="font-sans text-xs font-medium uppercase tracking-wider text-gold-dark mb-3">Follow us</p>
                <div className="flex gap-3">
                  {contactInfo.social.map((item) => (
                    <a
                      key={item.name}
                      href={item.href}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-10 h-10 rounded-sm bg-gold-muted/20 flex items-center justify-center text-gold-dark hover:bg-gold-primary/30 hover:text-aura-text transition-colors"
                      aria-label={item.name}
                    >
                      <SocialIcon icon={item.icon} />
                    </a>
                  ))}
                </div>
              </div>

              <div className="border-l-2 border-gold-primary pl-6 py-2">
                <p className="font-sans text-sm text-aura-text">
                  For inquiries, partnerships, or project discussions, use the
                  form or reach out directly. We look forward to hearing from you.
                </p>
              </div>
            </motion.div>

            <motion.form
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
              onSubmit={handleSubmit}
              className="space-y-6"
            >
              <div>
                <label htmlFor="name" className="block font-sans text-sm font-medium text-aura-text mb-2">
                  Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formState.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-sm border border-gold-muted/30 bg-aura-bg text-aura-text placeholder-gold-muted/60 focus:outline-none focus:ring-2 focus:ring-gold-primary/50 focus:border-gold-primary transition-colors"
                  placeholder="Your name"
                />
              </div>
              <div>
                <label htmlFor="phone" className="block font-sans text-sm font-medium text-aura-text mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formState.phone}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-sm border border-gold-muted/30 bg-aura-bg text-aura-text placeholder-gold-muted/60 focus:outline-none focus:ring-2 focus:ring-gold-primary/50 focus:border-gold-primary transition-colors"
                  placeholder="Your phone number"
                />
              </div>
              <div>
                <label htmlFor="email" className="block font-sans text-sm font-medium text-aura-text mb-2">
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formState.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 rounded-sm border border-gold-muted/30 bg-aura-bg text-aura-text placeholder-gold-muted/60 focus:outline-none focus:ring-2 focus:ring-gold-primary/50 focus:border-gold-primary transition-colors"
                  placeholder="your@email.com"
                />
              </div>
              <div>
                <label htmlFor="subject" className="block font-sans text-sm font-medium text-aura-text mb-2">
                  Subject
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formState.subject}
                  onChange={handleChange}
                  className="w-full px-4 py-3 rounded-sm border border-gold-muted/30 bg-aura-bg text-aura-text placeholder-gold-muted/60 focus:outline-none focus:ring-2 focus:ring-gold-primary/50 focus:border-gold-primary transition-colors"
                  placeholder="What is this regarding?"
                />
              </div>
              <div>
                <label htmlFor="message" className="block font-sans text-sm font-medium text-aura-text mb-2">
                  Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  value={formState.message}
                  onChange={handleChange}
                  required
                  rows={5}
                  className="w-full px-4 py-3 rounded-sm border border-gold-muted/30 bg-aura-bg text-aura-text placeholder-gold-muted/60 focus:outline-none focus:ring-2 focus:ring-gold-primary/50 focus:border-gold-primary transition-colors resize-none"
                  placeholder="Your message..."
                />
              </div>
              <motion.button
                type="submit"
                disabled={isSubmitting}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="w-full sm:w-auto px-8 py-3 rounded-sm bg-gold-primary text-aura-text font-sans text-sm font-medium tracking-wide hover:bg-gold-dark transition-colors duration-300 disabled:opacity-70 disabled:cursor-not-allowed"
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </motion.button>
              {submitStatus === "success" && (
                <p className="mt-3 font-sans text-sm text-emerald-600">
                  Thank you. Your message has been sent.
                </p>
              )}
              {submitStatus === "error" && (
                <p className="mt-3 font-sans text-sm text-red-600">
                  Something went wrong. Please try again in a moment.
                </p>
              )}
            </motion.form>
          </div>
        </div>
      </section>
    </PageWrapper>
  );
}
